import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  createAssessmentFeedbackApiService,
  type CreateAssessmentFeedbackRequest,
  type CreateAssessmentFeedbackResult,
} from "@/generated/fastapi";

export async function createAssessmentFeedback(
  accessToken: string | null | undefined,
  request: CreateAssessmentFeedbackRequest,
): Promise<CreateAssessmentFeedbackResult> {
  const response = await createAssessmentFeedbackApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to save feedback (${response.status})`);
  }

  if (response.data.status !== "created") {
    throw new Error(response.data.message || "Failed to save feedback");
  }

  return response.data;
}
